import { render } from "./TextAnswer.vue?vue&type=template&id=ce0512e2"
import script from "./TextAnswer.vue?vue&type=script&lang=js"
export * from "./TextAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__